module.exports = __webpack_public_path__ + "static/media/whatsapp.9842e6ae.svg";